import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-process-dialog',
    templateUrl: './process-dialog.component.html',
    styleUrls: ['./process-dialog.component.scss'],
    standalone: false
})
export class ProcessDialogComponent implements OnInit {
  public projectStatus = 'processing';

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ProcessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public obj: any
  ) {
    if ('projectStatus' in obj.data) {
      this.projectStatus = obj.data.projectStatus;
    }
  }

  ngOnInit(): void {
    if (this.projectStatus === 'processing') {
      this.timer();
    }
  }

  public timer() {
    setTimeout(() => {
      this.projectStatus = 'failed';
    }, 30000);
  }

  public close() {
    this.dialogRef.close();
  }

  public requestSupportDialog() {
    this.dialogRef.close('support');
  }

  public refreshResults() {
    this.dialogRef.close('restart');
  }
}
